import React, { useEffect, useState } from 'react'
import Link from '../Link'
import BackgroundImage from 'gatsby-background-image'
import useWindowSize from '../../hooks/useWindowSize'

import {
  fullWidthCalloutContainer,
  dark,
  titleText,
  linkText,
} from './index.module.css'

const FullWidthCalloutWithImage = ({
  subtitle,
  images,
  mobileOnlyImages,
  ctaUrl,
  ctaText,
  isDarkTheme,
}) => {
  const size = useWindowSize()
  const [isMobile, setMobile] = useState(false)

  useEffect(() => {
    setMobile(size.width <= 500)
  }, [size.width])

  let image = images[0]

  if (isMobile && mobileOnlyImages) {
    image = mobileOnlyImages[0]
  }

  let classes = fullWidthCalloutContainer

  if (isDarkTheme) {
    classes += ` ${dark}`
  }

  return (
    <BackgroundImage className={classes} image={image.gatsbyImageData}>
      <h3 className={titleText}>{subtitle.subtitle}</h3>
      <Link to={ctaUrl}>
        <button className={linkText}>{ctaText}</button>
      </Link>
    </BackgroundImage>
  )
}

export default FullWidthCalloutWithImage
